module.exports = __webpack_public_path__ + "img/0100.82c789df.jpg";